export const LDAP_GROUP = 'LDAP Group';
export const AD_GROUP = 'Active Directory Group';
export const AD_GROUP_MEMBERSHIP_REMOVAL = 'Active Directory Group Membership Removal';
export const AD_GROUP_OWNER_CHANGE = 'Group Owner Change';
export const PRIVILEGED = 'Privileged';
export const NON_PRIVILEGED = 'Non-Privileged';

export const REQUEST_TYPE = {
    NEW: 'New',
    MODIFY: 'Modify',
    DISABLE_GROUP: 'Disable',
};

export const MODIFY_REQUEST_TYPE = {
    MEMBERSHIP: 'Membership',
    REMOVAL: 'Removal',
    GROUP_OWNER_CHANGE: 'Group Owner Change',
};

export default {};
